import { MatchEventChecker as MatchEventCheckerComponent } from './MatchEventChecker.component'
import { connector } from './MatchEventChecker.connector'

export const MatchEventChecker = connector(MatchEventCheckerComponent);
